import React, { Children } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: 1,
  title: 'Todos los Códigos que Necesitas para Construir una Página de Producto Ganadora',
  description: 'Secciones, estructuras y snippets listos para aumentar conversión.'
}, {
  number: 2,
  title: 'Cómo Crear Portadas de Productos que Venden: Diseños Profesionales con IA',
  description: 'Plantillas editables para creatividades y presentaciones premium.'
}, {
  number: 3,
  title: 'Cómo Encontrar Ofertas de Productos Ganadores Ya Validados',
  description: 'Cómo detectar ofertas ganadoras y modelar sin copiar.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BonusSection() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-16 md:pb-24 px-6" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        {/* CTA Button */}
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-37">
          <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-green hover:bg-brand-green-hover text-brand-bg font-bold text-lg px-10 py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20" data-id="element-38">
            🔥 Empezar Ahora
          </a>
        </motion.div>

        {/* Bonos intro */}
        <motion.p className="text-2xl md:text-3xl text-white/70 text-center mb-3" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-39">
          Y esto no es todo…
        </motion.p>

        {/* Bonos heading */}
        <motion.h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-40">
          🎁 Además te llevás 3 bonos que aceleran tus resultados totalmente
          ¡GRATIS!
        </motion.h2>

        {/* Bonus Cards */}
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-41">
          {bonuses.map(bonus => <motion.div key={bonus.number} variants={itemVariants} className="bg-brand-card rounded-2xl border border-white/10 p-6 flex flex-col gap-4 shadow-lg shadow-black/10 hover:border-brand-green/50 hover:shadow-brand-green/15 hover:-translate-y-1 transition-all duration-300 cursor-default" data-id="element-42">
              {/* Badge */}
              <span className="inline-block self-start bg-brand-green text-brand-bg text-sm font-bold px-4 py-1.5 rounded-lg" data-id="element-43">
                Bono #{bonus.number}
              </span>

              {/* Title */}
              <h3 className="text-lg font-bold text-white leading-snug" data-id="element-44">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-brand-dark/60 text-sm leading-relaxed" data-id="element-45">
                {bonus.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}